"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ContestBannerHeaderKickoff = _interopRequireDefault(require("./ContestBannerHeaderKickoff"));

var _ContestBannerHeaderPrize = _interopRequireDefault(require("./ContestBannerHeaderPrize"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  display: flex;\n  height: 4rem;\n  color: ", ";\n  background: ", ";\n"])), function (p) {
  return p.theme.colorPicksBannerText || p.theme.colorPrimaryText || "rgba(255, 255, 255, 0.96)";
}, function (p) {
  return p.isLoading ? p.theme.colorSkeleton : p.theme.colorPicksBannerBackground || p.theme.colorPrimary;
});

var Wrapper = function Wrapper(_ref) {
  var activePickem = _ref.activePickem,
      translations = _ref.translations,
      language = _ref.language;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    isLoading: !activePickem,
    children: activePickem && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestBannerHeaderPrize.default, {
        translations: translations,
        language: language,
        prizePool: activePickem === null || activePickem === void 0 ? void 0 : activePickem.prizeFund
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestBannerHeaderKickoff.default, {
        translations: translations,
        language: language,
        kickoff: activePickem === null || activePickem === void 0 ? void 0 : activePickem.start
      })]
    })
  });
};

var _default = Wrapper;
exports.default = _default;